import {
  loginFailure,
  loginStart,
  loginSuccess,
  registerStart,
  registerSuccess,
  registerFailure,
} from "../redux/userRedux";
import { BASE_URL, userRequest, publicRequest } from "../requestMethods";
import { toast } from "react-toastify";

export const verifyNumber = async (mail, callback) => {
  try {
    return await publicRequest.post(`labApi/auth/verifyNumber`, mail);
  } catch (err) {
    console.log(err, "err at verify mail api");
    callback(err?.response?.data?.err);
    return err;
  }
};

export const verifyOtp = async (otpData) => {
  return await publicRequest.post(`labApi/auth/verifyOTP`, otpData);
};

export const hospitalReg = async (dispatch, details, callback) => {
  dispatch(registerStart());
  try {
    const res = await publicRequest.post(`labApi/auth/labRegisteration`, details);
    dispatch(registerSuccess(res.data));
    callback(res.data);
  } catch (err) {
    callback(err?.response?.data?.err);
    dispatch(registerFailure());
  }
};

export const login = async (dispatch, user, callback) => {
  dispatch(loginStart());
  try {
    const res = await publicRequest.post(`labApi/auth/labLogin`, user);
    if (res.status === 200) {
      dispatch(loginSuccess(res.data));
      localStorage.setItem("UserDetailToken", res?.data?.accessToken);
      callback(res);
    }
  } catch (err) {
    toast.error(err?.response?.data || "Login failed");
    dispatch(loginFailure());
  }
};

export const getSelectedProfileData = async (labId) => {
  // dispatch(getSubscriptionStart());
  try {
    const res = await userRequest.get(`labApi/profile/getProfileData/${labId}`);
    // console.log(res, "res.data");
    if (res.status === 200) {
      return res.data.data;
    }
  } catch (err) {
    toast.error(err?.response?.data);
    console.log(err, "err at sel subs");
  }
};

export const updateProfile = async (data, labId) => {
  try {
    console.log(data, labId, "data");
    // return
    const res = await userRequest.patch(
      `labApi/profile/updateProfile/${labId}`,
      data
    );

    if (res.status === 200) {
      console.log(res.data, "res from backend");
      toast.success(res?.data?.message);
      return res.data.data;
    }
  } catch (err) {
    console.log(err, "err at sel subs");
    toast.error(err.message);
  }
};


export const updateLeagalInfo = async (data, labId) => {
  try {
    console.log(data, labId, "data");
    // return
    const res = await userRequest.patch(
      `labApi/profile/updateLegalInfo/${labId}`,
      data
    );

    if (res.status === 200) {
      console.log(res.data, "res from backend");
      toast.success(res?.data?.message);
      return res.data.data;
    }
  } catch (err) {
    console.log(err, "err at sel subs");
    toast.error(err.message);
  }
};

export const updateAboutInfo = async (data, labId) => {
  try {
    console.log(data, labId, "data");
    // return
    const res = await userRequest.patch(
      `labApi/profile/updateAboutInfo/${labId}`,
      data
    );

    if (res.status === 200) {
      console.log(res.data, "res from backend");
      toast.success(res?.data?.message);
      return res.data.data;
    }
  } catch (err) {
    console.log(err, "err at sel subs");
    toast.error(err.message);
  }
};

export const updateLabTimings = async (labId, data) => {
  try {
    console.log(data, labId, "data");
    const res = await userRequest.post(
      `labApi/profile/updateLabTiming/${labId}`,
      data
    );
    if (res.status === 200) {
      console.log(res.data, "res from backend");
      toast.success(res?.data?.message);
      return res.data.data;
    }
  } catch (err) {
    console.log(err, "err at sel subs");
    toast.error(err.message);
  }
};

export const updateLabStatus = async (id) => {
  try {
    const res = await userRequest.patch(`labApi/profile/updateLabStatus/${id}`);
    console.log(res, 'res')

    return res;

  } catch (err) {
    console.log(err);
  }
};


export const uploadLabDocs = async (data, docType, labId, callback) => {
    try {
        console.log(labId, 'user from excl upload');
        // return
        const res = await userRequest.post(`/labApi/profile/uploadLabDocs/${labId}?docType=${docType}`, data);
        console.log(res.data, 'res')
        // return
        if (res.status === 200) {
            toast.success(`🦄 ${res.data.message}`);
            callback(res.data)
        }
    } catch (err) {
        console.log(err, "err at upload count");

        toast.error(`🦄 ${err.response.data.message}`);
        return err;
    }
};


export const getLabImgDataById = async (id) => {
  try {
    console.log(id, 'iddfgf hgs')
    const res = await userRequest.get(`labApi/profile/getLabImages/${id}`);
    console.log(res.data, 'res from update get data from id')
    // return
    if (res.status === 200) {
      return res.data.data
    }
  }
  catch (err) {
    console.log(err, 'err at get test id data')
    toast.error(`Server Error Happens`);
  }
}

export const uploadGalleryDocs = async (data, docType, labId, callback) => {
    try {
        console.log(labId, 'user from excl upload');
        // return
        const res = await userRequest.post(`/labApi/profile/uploadGalleryLabDocs/${labId}?docType=${docType}`, data);
        console.log(res.data, 'res')
        // return
        if (res.status === 200) {
            toast.success(`🦄 ${res.data.message}`);
            callback(res.data)
        }
    } catch (err) {
        console.log(err, "err at upload count");

        toast.error(`🦄 ${err.response.data.message}`);
        return err;
    }
};


export const getLabGalleryDataById = async (id) => {
  try {
    console.log(id, 'iddfgf hgs')
    const res = await userRequest.get(`labApi/profile/getGalleryLabImages/${id}`);
    console.log(res.data, 'gallery res from update get data from id')
    // return
    if (res.status === 200) {
      return res.data.data
    }
  }
  catch (err) {
    console.log(err, 'err at get test id data')
    toast.error(`Server Error Happens`);
  }
}

export const updateLabHighlights = async (data, labId) => {
  console.log(data, 'lab highlight data')
  console.log(labId, 'lab id')
  // return
  try {
    const res = await userRequest.post(
      `labApi/profile/saveLabHighlights/${labId}`,
      data
    );
    if (res.status === 200) {
      toast.success(res?.data?.message || "Highlights saved");
      return res.data.data;
    }
  } catch (err) {
    console.log(err, "err at updateLabHighlights");
    toast.error(err?.message || "Failed to save highlights");
  }
};

export const getLabHighlights = async (labId) => {
  try {
    const res = await userRequest.get(`labApi/profile/getLabHighlights/${labId}`);
    if (res.status === 200) return res.data.data;
  } catch (err) {
    console.log(err, "err at getLabHighlights");
    toast.error("Failed to fetch highlights");
  }
};

export const getLabTimings = async (labId) => {
  try {
    const res = await userRequest.get(`labApi/profile/getLabTiming/${labId}`);
    if (res.status === 200) return res.data.data;
  } catch (err) {
    console.log(err, "err at getLabTimings");
    toast.error("Failed to fetch lab timings");
  }
};
